export default class Spicie {
    constructor(physioGnomicTypes, generalDistributions, habitats, commonNames, locations, synonyms ,name, subSpecie, descriptor, gender, family, order, subclass, speciesClass, subdivision, division, images, floweringStartSeason, floweringEndSeason) {
        // Translations required fields
        this.physioGnomicTypes = physioGnomicTypes;
        this.generalDistributions = generalDistributions;
        // Arrays
        this.habitats = habitats;
        this.commonNames = commonNames;
        this.locations = locations;
        this.synonyms = synonyms;
        // Normal Fields
        this.name = name;
        this.subSpecie = subSpecie;
        this.descriptor = descriptor;
        this.gender = gender;
        this.family = family;
        this.order = order;
        this.subclass = subclass;
        this.class = speciesClass;
        this.subdivision = subdivision;
        this.division = division;
        this.images = images;
        this.floweringStartSeason = floweringStartSeason;
        this.floweringEndSeason = floweringEndSeason; 
    }

    isValid() {
        var result = true;

        for (const [key, value] of Object.entries(this.physioGnomicTypes)) { if(!value) { result = false; break; }; }
        for (const [key, value] of Object.entries(this.generalDistributions)) { if(!value) { result = false; break; }; }
        
        for (const [key, value] of Object.entries(this.habitats)) { if(!value) { result = false; break; }; }
        for (const [key, value] of Object.entries(this.commonNames)) { if(!value) { result = false; break; }; }
    
        if(result) result = this.locations && this.locations.length && this.synonyms && this.synonyms.length && this.name && this.subSpecie && this.descriptor && this.gender && this.family && this.order && this.subclass && this.class && this.subdivision && this.division && this.images && this.floweringStartSeason && this.floweringEndSeason;
        
        return result;
    }
}